<script>
	import { createEventDispatcher } from 'svelte';

  //liblary 
  import axios from "axios"; 

  import { session, notif } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  let _token = localStorage.getItem("t");

 
	const dispatch = createEventDispatcher();

  export let jumlahorder;
  export let id;
  $: jumlahorder = parseInt(jumlahorder);
  let maxjumlahorder = 99999;
  let minjumlahorder = 1;
  function plusCart() {
    if (jumlahorder >= maxjumlahorder) {
      jumlahorder = maxjumlahorder;
    } else {
      if ((jumlahorder < 1) | !jumlahorder) {
        jumlahorder = 1;
      } else {
        jumlahorder = parseInt(jumlahorder) + parseInt(1);
      }
    }
  }
  function minCart() {
    if (jumlahorder <= minjumlahorder) {
      jumlahorder = minjumlahorder;
    } else {
      if ((jumlahorder < 1) | !jumlahorder) {
        jumlahorder = 1;
      } else {
        jumlahorder = jumlahorder - 1;
      }
    }
  }
  function cartUpdate(){   
    
    axios
        .post(
          settings.url + "/sipade/cart?authorization=" + settings.token,
          {
            productID: id,
            quantity: jumlahorder,
            update:true
          }
        )
        .then(function (response) { 
          jumlahorder = parseInt(jumlahorder) || 1
          dispatch('message', {
          text: jumlahorder
          });
          load_notif();
        })
        .catch(function (error) {
          window.location.reload()
          if (error.response.status == 401) {
            localStorage.removeItem("t");  
          }

          
        }); 
  }
  function load_notif() {
    if (_token) {
      axios
        .get(settings.url + "/sipade/notif", {
          params: {
            authorization: _token,
          },
        })
        .then(function (response) {
          notif.update((n) => response.data.notif);
        }); 
    }
  }
</script>

<i
  class="cursor-pointer select-none p-1 rounded-full text-md text-center
    transform transition-all duration-300 scale-100 hover:scale-110 m-r-2 mt-1
    w-8 h-8 outline-none"
  on:click|preventDefault={minCart} on:click|preventDefault={cartUpdate} on:click>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    class="w-5 h-5 mx-auto">
    <path
      d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm5-9v2H5V9h10z" /></svg>
</i>
<input
  type="number"
  bind:value={jumlahorder} on:blur={cartUpdate}
  min="1"
  name="quantity"
  class="w-16 relative border border-gray-400 py-1 outline-none text-center
    quantity appearance-none rounded-lg mx-2" />
<i
  class="cursor-pointer select-none p-1 rounded-full text-md text-center
    transform transition-all duration-300 scale-100 hover:scale-110 m-r-2 mt-1
    w-8 h-8 outline-none"
    on:click|preventDefault={plusCart} on:click|preventDefault={cartUpdate}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    class="w-5 h-5 mx-auto"><path
      d="M11 9h4v2h-4v4H9v-4H5V9h4V5h2v4zm-1 11a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z" /></svg>
</i>
